export enum ESIZE_PICTURE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
export interface PARENT_UPDATE_PROFILE_REQUEST {
  first_name?: string;
  last_name?: string;
  bio?: string;
  profile_picture?: string;
}

export interface PARENT_UPLOAD_FILE_RESPONSE {
  url?: string;
}

export interface PARENT_CHANGE_PASSWORD_REQUEST {
  old_password: string;
  new_password: string;
  confirm_password: string;
}

export interface NOTIFY_SETTING_PAYLOAD {
  is_email_notification?: boolean;
  is_push_notification?: boolean;
}
